"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RepositoryEventEmitter_1 = require("./RepositoryEventEmitter");
/**
 * Repository Core implementation
 */
var RepositoryCore = /** @class */ (function () {
    function RepositoryCore(map) {
        this.map = map;
        this.events = new RepositoryEventEmitter_1.RepositoryEventEmitter();
    }
    /**
     * Get last saved entity if exist.
     * This is useful on client-side implementation.
     * Because, client-side often access-user is a single user.
     */
    RepositoryCore.prototype.getLastSaved = function () {
        return this.lastUsed;
    };
    /**
     * Find a entity by `entityIdentifier` that is instance of Identifier class.
     * Return `undefined` if not found entity.
     */
    RepositoryCore.prototype.findById = function (entityIdentifier) {
        if (!entityIdentifier) {
            return;
        }
        return this.map.get(String(entityIdentifier.toValue()));
    };
    /**
     * Find all entity that `predicate(entity)` return true
     */
    RepositoryCore.prototype.findAll = function (predicate) {
        return this.map.values().filter(predicate);
    };
    /**
     * Get all entities
     */
    RepositoryCore.prototype.getAll = function () {
        return this.map.values();
    };
    /**
     * Save entity to the repository.
     */
    RepositoryCore.prototype.save = function (entity) {
        this.lastUsed = entity;
        this.map.set(String(entity.props.id.toValue()), entity);
        this.events.emit(new RepositoryEventEmitter_1.RepositorySavedEvent(entity));
    };
    /**
     * Delete entity from the repository.
     */
    RepositoryCore.prototype.delete = function (entity) {
        this.map.delete(String(entity.props.id.toValue()));
        if (this.lastUsed === entity) {
            delete this.lastUsed;
        }
        this.events.emit(new RepositoryEventEmitter_1.RepositoryDeletedEvent(entity));
    };
    /**
     * Delete entity by `entityIdentifier` that is instance of Identifier class.
     */
    RepositoryCore.prototype.deleteById = function (entityIdentifier) {
        if (!entityIdentifier) {
            return;
        }
        var entity = this.findById(entityIdentifier);
        if (entity) {
            this.delete(entity);
        }
    };
    /**
     * Clear all entity
     */
    RepositoryCore.prototype.clear = function () {
        var _this = this;
        this.map.forEach(function (entity) { return _this.delete(entity); });
    };
    return RepositoryCore;
}());
exports.RepositoryCore = RepositoryCore;
//# sourceMappingURL=RepositoryCore.js.map